module.exports = __webpack_public_path__ + "static/media/14.aca65f3a.jpg";